/**
 * Nutrition is stored per 100 g. The single place that scales it to a
 * quantity: valueForQuantity = valuePer100g × grams / 100.
 */

const round = (value, dp) => {
  const f = 10 ** dp;
  return Math.round(value * f) / f;
};

/** One nutrient for `grams`; null stays null (unknown is never shown as 0). */
export function scaleNutrient(valuePer100g, grams, dp = 1) {
  if (valuePer100g === null || valuePer100g === undefined || !(grams > 0)) return null;
  return round((valuePer100g * grams) / 100, dp);
}

/** Every macro in a per-100 g object, for `grams`. Calories are whole numbers. */
export function scaleNutrition(per100g, grams) {
  if (!per100g || !(grams > 0)) return null;
  return Object.fromEntries(
    Object.entries(per100g).map(([key, value]) => [key, scaleNutrient(value, grams, key === "calories" ? 0 : 1)]),
  );
}
